<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card :loading="loading">
              <v-card-title class="pb-5">
                <v-btn
                  @click="$router.push('/admin/WorkReports')"
                  class="btn-back"
                >
                  <span class="flaticon2-reply icon-lg"></span>
                  بازگشت
                </v-btn>
                <v-spacer />
                {{ $t($route.meta.title) }}
                <v-spacer />
                <v-btn
                  @click="addDiscount"
                  class="submit-btn"
                  :loading="loading"
                >
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <date-picker
                      v-model="started_at"
                      label="ساعت شروع"
                      format="YYYY-MM-DD HH:mm:ss"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>

                    <p class="mt-2 text-danger">
                      {{ this.$options.filters.longDate(started_at) }}
                    </p>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <date-picker
                      v-model="expired_at"
                      label="ساعت پایان"
                      format="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>

                    <p class="mt-2 text-danger">
                      {{ this.$options.filters.longDate(expired_at) }}
                    </p>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="learning_time"
                      :error-messages="
                        errors !== [] ? errors.learning_time : ''
                      "
                      type="number"
                      label="زمان صرف شده برای آموزش(بر حسب ساعت)"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-radio-group
                      :error-messages="
                        errors !== [] ? errors.company_presence : ''
                      "
                      v-model="row"
                      row
                    >
                      <v-radio label="حضور در شرکت" value="present"></v-radio>
                      <v-radio label="دورکاری" value="telecommuting"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-checkbox
                      label="مرخصی ساعتی"
                      v-model="vacation"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-checkbox
                      label="کارکرد ساعتی"
                      v-model="hourly"
                    ></v-checkbox>
                  </v-flex>
                </v-row>

                <v-row v-if="hourly">
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2" v-if="hourly">
                    <v-text-field
                      v-model="endHour"
                      @keypress="isNumberKey"
                      :error-messages="errors !== [] ? errors.end_hour : ''"
                      type="text"
                      maxlength="2"
                      label="دقیقه"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2" v-if="hourly">
                    <v-text-field
                      v-model="startHour"
                      @keypress="isNumberKey"
                      :error-messages="errors !== [] ? errors.start_hour : ''"
                      type="text"
                      maxlength="2"
                      label="ساعت"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-row>

                <v-row v-if="vacation">
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2" v-if="vacation">
                    <date-picker
                      v-model="vacation_started_at"
                      label="ساعت شروع مرخصی"
                      format="YYYY-MM-DD HH:mm"
                      type="time"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2" v-if="vacation">
                    <date-picker
                      v-model="vacation_expired_at"
                      label="  ساعت پایان مرخصی"
                      format="YYYY-MM-DD HH:mm"
                      type="time"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex class="p-2">
                    <div v-if="errors.length !== 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="errors.description"
                        v-for="(des, ind) in errors.description"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                    <ckeditor
                      @focus="info"
                      :editor="editor.editor"
                      v-model="description"
                      :config="editor.editorConfig"
                    ></ckeditor>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import userPicker from "@/view/pages/pickers/userPicker";

export default {
  components: { userPicker, priceInput },
  props: ["id"],
  data() {
    return {
      service: [],
      services: [],
      users: [],
      title: null,
      vacation: false,
      vacation_started_at: null,
      vacation_expired_at: null,
      learning_time: 0,
      hourly: false,
      startHour: null,
      endHour: null,
      started_at: null,
      row: null,
      picture: null,
      code: null,
      target: null,
      price_max: 0,
      expire: null,
      usable: 0,
      permissions: {},
      roleid: null,
      point: null,
      loading: false,
      discount: null,
      time: null,
      expired_at: null,
      tariff: {},
      rb: {
        rb: {
          number: null,
          chat: null,
          new: null,
          unique: null,
        },
      },
      subline: {},
      tariffs: [],
      owner: { id: null },
      show: { id: null },
      sortOrder: null,
      features: [],
      description: null,
      roles: [],
      errors: [],
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      rules: {
        title: [
          (val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد.",
        ],
        services: [(val) => val.length > 0 || "فیلد سرویس الزامی می باشد."],
        price: [(val) => (val || "").length > 0 || "فیلد قیمت الزامی می باشد."],
        expire: [
          (val) => (val || "").length > 0 || "فیلد تاریخ انقضا الزامی می باشد.",
        ],
        // permissions: [val => (val || []).length > 0 || 'فیلد دسترسی الزامی می باشد.'],
        // tariff: [val => !!val || 'فیلد تعرفه الزامی می باشد.'],
      },
    };
  },

  created() {
    this.findReport();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
  watch: {
    vacation(value) {
      if (!value) {
        this.vacation_started_at = null;
        this.vacation_expired_at = null;
      }
    },
  },

  methods: {
    findReport() {
      this.loading = true;
      this.requestApiGet(`admin/workReports/show/${this.id}`)
        .then(({ data }) => {
          this.description = data.description;
          this.started_at = data.start_date;
          this.expired_at = data.end_date;
          this.learning_time = data.learning_time;
          this.row = data.company_presence;
          this.description = data.description;
          if (data.vacation_start_date) {
            this.vacation = true;
            this.vacation_started_at = data.vacation_start_date;
            this.vacation_expired_at = data.vacation_end_date;
          }

          if (data.start_hour) {
            this.hourly = true;
            this.startHour = data.start_hour;
            this.endHour = data.end_hour;
          }

          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },

    getPacks() {
      this.requestApiGet("pack").then(({ data }) => {
        this.services = data.data;
      });
    },
    addDiscount() {
      this.loading = true;

      if (this.vacation) {
        this.requestApiPost(`admin/workReports/edit/${this.id}`, {
          started_at: this.started_at,
          expired_at: this.expired_at,
          learning_time: this.learning_time,
          start_vacation: this.vacation_started_at,
          end_vacation: this.vacation_expired_at,
          vacation: this.vacation,
          company_presence: this.row,
          description: this.description,
        })
          .then((response) => {
            this.loading = false;
            this.$toast.success("گزارش کار با موفقیت ویرایش شد.");
            this.$router.push({ name: "admin.workReports.index" });
          })
          .catch(({ response }) => {
            this.errors = response.data.errors;
            this.loading = false;
          });
      } else {
        this.requestApiPost("workReports", {
          started_at: this.started_at,
          expired_at: this.expired_at,
          learning_time: this.learning_time,
          company_presence: this.row,
          description: this.description,
        })
          .then((response) => {
            this.loading = false;
            this.$toast.success("گزارش کار با موفقیت ویرایش شد.");
            this.$router.push({ name: "admin.workReports.index" });
          })
          .catch(({ response }) => {
            if (response.data.errors.today) {
              this.$toast.error(response.data.errors.today[0]);
            }
            this.errors = response.data.errors;
            this.loading = false;
          });
      }
    },
    info() {
      this.$toast.info("لطفا قبل از نوشتن گزارش روی دکمه لیست عددی کلیک کنید.");
    },
    setEdited(x) {
      x.edited = true;
    },
    createRegister() {
      this.register.push({
        organName: "",
        type: null,
        date: "",
      });
    },
    picked(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files.length >= 1) {
        this.picture = files[0];
        let avatarBlock = document.getElementById("avatar-block");
        let fileReader = new FileReader();
        fileReader.onload = function (e) {
          let preview = avatarBlock.getElementsByClassName("v-image__image")[0];
          preview.style.backgroundImage = "url('" + this.result + "')";
          preview.style.display = "block";
        };
        fileReader.readAsDataURL(files[0]);
      }
    },
    addCount() {
      this.features.push({
        id: this.features.length + 1,
        key: null,
        value: null,
      });
    },
    decreaseCount() {
      if (this.features.length > 0) {
        this.features.pop();
      }
    },
  },
};
</script>
